import { Component, OnInit } from "@angular/core";
// import { FormBuilder, FormGroup, Validators } from "@angular/forms";
// import { EmailService } from "../services/email/email.service";

@Component({
  selector: 'app-hispanic-heritage-month',
  templateUrl: './hispanic-heritage-month.component.html',
  styleUrls: ['./hispanic-heritage-month.component.scss']
})
export class HispanicHeritageMonthComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  scrollToForm(idSelector: string): void {
    document.getElementById(idSelector).scrollIntoView({'behavior':'smooth'});
  }

  // rodScrollIntoView = (selector) => {
  //   window.scrollTo({
  //     behavior: 'smooth',
  //     top:
  //       document.querySelector(selector).getBoundingClientRect().top -
  //       document.body.getBoundingClientRect().top -
  //       30,
  //   });
  // }

  // public artworksForm: FormGroup;
  // public artworksSuccess = false;
  // public formSubmitting = false;
  // public showErrorMessage = false;
  // public fileValidationPassed = true;
  // public artworkFileName = "";
  // public artworkFileData: any;

  // constructor(private _fb: FormBuilder, private _emailService: EmailService) {
  //   this.artworksForm = _fb.group({
  //     name: [null, Validators.required],
  //     email: ["", [Validators.required, Validators.pattern("[^ @]*@[^ @]*")]],
  //     phone: ["", Validators.required],
  //     city: ["", Validators.required],
  //     artworkTitle: ["", Validators.required],
  //     artworkInfo: ["", Validators.required],
  //     artworkFile: ["", Validators.required],
  //     artistInfo: ["", Validators.required],
  //     agreement: [false, Validators.requiredTrue],
  //   });
  // }

  // submitForm() {

  //   if (!this.artworksForm.invalid && Boolean(this.fileValidationPassed)) {
  //     this.formSubmitting = true;
  //     this.showErrorMessage = false;

  //     const formObject = {
  //       name: this.artworksForm.controls.name.value,
  //       email: this.artworksForm.controls.email.value,
  //       phone: this.artworksForm.controls.phone.value,
  //       city: this.artworksForm.controls.city.value,
  //       artworkTitle: this.artworksForm.controls.artworkTitle.value,
  //       artworkInfo: this.artworksForm.controls.artworkInfo.value,
  //       artistInfo: this.artworksForm.controls.artistInfo.value,
  //       agreement: this.artworksForm.controls.agreement.value,
  //       artworkFileName: this.artworkFileName,
  //       artworkFileData: this.artworkFileData,
  //     };

  //     console.clear();
  //     console.info(formObject.artworkFileData);

  //     this._emailService
  //       .sendMuralsFormData(formObject)
  //       .then(result => {
  //         console.info("Success!\n", result);
  //         this.artworksSuccess = true;
  //         this.formSubmitting = false;
  //         this.scrollToForm();
  //       })
  //       .catch(error => {
  //         console.info("Error!\n", error);
  //       });
  //   } else {
  //     this.showErrorMessage = true;
  //   }
  // }

  // validateFile(fileEvent: any) {
  //   const file: File = fileEvent.target.files[0];
  //   let maxBytes = 16 * 1000000; // Multiply the megabytes you want to get the bytes 😁
  //   let muralComponent = this;

  //   if(file.size > maxBytes) {
  //     console.error('File size too big! 😵');
  //     this.fileValidationPassed = false;
  //     return;
  //   }

  //   if(['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)){    
  //     console.info('File type validation passed! 😄');  
  //     this.fileValidationPassed = true;
  
  //     var fileReader = new FileReader();
  //     fileReader.onload = function() {

  //       muralComponent.artworkFileName = file.name;
  //       muralComponent.artworkFileData = fileReader.result;
  //       console.info(muralComponent.artworkFileName);
  //       console.info(muralComponent.artworkFileData);
  //       console.info(JSON.stringify(Array.from(new Uint8Array(muralComponent.artworkFileData))));
  //       muralComponent.artworkFileData = JSON.stringify(Array.from(new Uint8Array(muralComponent.artworkFileData)));
  //     }

  //     // fileReader.readAsDataURL(file);
  //     fileReader.readAsArrayBuffer(file);
  //   } else {
  //     console.error('File type validation failed! 😵');
  //     this.fileValidationPassed = false;
  //   }
  // }

}


// WEBPACK FOOTER //
// ./src/app/hispanic-heritage-month/hispanic-heritage-month.component.ts